module.exports = __webpack_public_path__ + "img/xu_icon.0a67a056.png";